import React from 'react'
import Select, { OptionProps, StylesConfig, components } from 'react-select'
import { customSelectValue } from './common'

export type NestedOption = {
  label: string
  value: number | string
  depth?: number
  name?: string
  ancestorsLabel?: string
  liquids?: boolean
  imageUrl?: string
}

type NestedDropdownProps = {
  placeholder: string
  value: Partial<NestedOption> | null
  options: NestedOption[]
  handleChange: (option: NestedOption | null) => void
  className?: string
}

const NestedOptionRow = (props: OptionProps<NestedOption, false>) => {
  const { imageUrl, ancestorsLabel, name, label } = props.data
  return (
    <components.Option {...props} className="select-option d-flex align-items-center">
      {imageUrl ? <img src={imageUrl} /> : null}
      {name ? (
        <div>
          {ancestorsLabel ? <span className="ancestry-prefix">{ancestorsLabel} / </span> : null}
          <span>{name}</span>
        </div>
      ) : (
        label
      )}
    </components.Option>
  )
}

// wrapper for react-select dropdown that takes another attribute - depth for each option
const NestedDropdown = ({ placeholder, value, options, handleChange, className = '' }: NestedDropdownProps) => {

  const styles: StylesConfig<NestedOption, false> = {
    option: (provided, state) => ({
      ...provided,
      fontWeight: state.isSelected ? "bold" : "normal",
      marginLeft: `${(state.data.depth ?? 0) * 15}px`
    })
  };

  const selectedValue = value && Object.keys(value).length > 0 ? (value as NestedOption) : null

  return <Select
    className={`react-select mb-3 ${className}`}
    classNamePrefix='react-select'
    placeholder={placeholder}
    options={options}
    styles={styles}
    value={selectedValue}
    onChange={handleChange}
    isSearchable={false}
    components={{
      Option: NestedOptionRow,
      SingleValue: customSelectValue,
      IndicatorSeparator: () => null
    }}
  />
}

export default NestedDropdown
